import clsx from "clsx"
import { isMobileOnly } from "react-device-detect"
import "./HelpInfo.scoped.scss"

type HelpInfoProps = {
	children: React.ReactNode
	className?: string
}

export const HelpInfo: React.FC<HelpInfoProps> = ({ children, className }) => {
	return (
		<div className={clsx("c-help", className, { "flex flex-col": isMobileOnly })}>
			{children}
		</div>
	)
}
